import { Component, Input } from '@angular/core';

@Component({
    selector: 'box-data',
    template: require('./box-data.component.html'),
    styles: [require('./box-data.component.scss')]
})
export class BoxDataComponent {
    @Input() public number: string;
    @Input() public titleBox: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/about/box-data/box-data.component.ts